export function dateRangePicker() {
  return {
    restrict: 'E',
    template: require('./date-range-picker.directive.html'),
    scope: {
      model: '=',
      noMaxDate: '<',
      noDefaultValue: '<',
      readonly: '<',
      localStorageKey: '<?',
      label: '<?',
      isMandatory: '<?',
      onCloseFn: '&?onClose'
    },
    controller: ctrl
  };
}

ctrl.$inject = ['$scope', 'AudienceFactory', 'DateRangePickerDialogFactory', 'LocalStorageFactory'];
function ctrl($scope, AudienceFactory, DateRangePickerDialogFactory, LocalStorageFactory) {

  $scope.pickDateRange = pickDateRange;
  $scope.toString = toString;
  $scope.callOnClose = callOnClose;

  init();

  function loadFromLocalStorage() {
    if ($scope.localStorageKey) {
      let val = LocalStorageFactory.getItem($scope.localStorageKey);
      if (val && val.value) {
        $scope.model.from = AudienceFactory.dateFromObj(val.value.from);
        $scope.model.to = AudienceFactory.dateFromObj(val.value.to);
      } else {
        setDefaultValue();
      }
    }
  }

  function saveToLocalStorage() {
    if ($scope.localStorageKey) {
      let toSave = null;
      if ($scope.model.from && $scope.model.to) {
        toSave = {
          from: AudienceFactory.dateToObj($scope.model.from),
          to: AudienceFactory.dateToObj($scope.model.to)
        };
      }
      LocalStorageFactory.setItem($scope.localStorageKey, { value: toSave });
    }
  }

  function setDefaultValue() {
    let from = new Date();
    from.setDate(from.getDate() - 7);
    $scope.model.from = from;
    $scope.model.to = new Date();
  }

  function pickDateRange($event) {
    DateRangePickerDialogFactory.show({
      fromDate: $scope.model.from,
      toDate: $scope.model.to,
      noMaxDate: $scope.noMaxDate,
      isMandatory: $scope.isMandatory === undefined || $scope.isMandatory === true,
      targetEvent: $event,
    }).then(result => {
      $scope.model.from = result.fromDate;
      $scope.model.to = result.toDate;
      saveToLocalStorage();
      callOnClose();          // Check if dateRange changed and update query
    });
  }

  function toString() {
    return AudienceFactory.dateRangeToString($scope.model);
  }

  function callOnClose() {
    if ($scope.onCloseFn) {
      $scope.onCloseFn();
    }
  }

  function init() {
    if (!$scope.noDefaultValue && !$scope.model.from && !$scope.model.to) {
      loadFromLocalStorage();
    }
  }
}